import { Title as TitleComponent } from "features/components"
import styled from "styled-components/macro"

export const ErrorPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  padding: 2rem;
`

export const Title = styled(TitleComponent)`
  margin-top: 6rem;
  text-align: center;
`

export const AnimationContainer = styled.div`
  margin-top: 5rem;

  div[aria-label="animation"] {
    max-width: 700px;
    // override lottie element style
    height: 500px !important;
  }
`
